import { createBreakpoint } from 'styled-components-breakpoint';

import { BREAKPOINT } from '../components/ThemeProvider/constants/breakpoints';

export const breakpoint = createBreakpoint(BREAKPOINT);
